import "./TemplatePage.css";

import React, { useEffect, useState } from "react";

import { useNavigate, useParams,useLocation } from "react-router-dom";

import axios from "axios";

import { END_URL } from "../../config";

import gg from "../../images/pp-logo.gif";

function TemplatePage({menuLink,randomTest,HubTemplateSlugs}) {

    const { slug } = useParams();

    const location = useLocation();

    const old_test_path = location.pathname.split('/').pop();

    const navigate = useNavigate();
    
    const [page, setPage] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    useEffect(() => {

        const container = document.querySelector('.priv-main');

        if (!container) return;

        const handleClick = (e) => {

            if (
                e.target.tagName === 'INPUT' &&
                e.target.type === 'button'
            ) {
                const url = e.target.name;

                if (url) {
                    window.open(url, '_blank');
                }
            }
        };

        container.addEventListener('click', handleClick);

        return () => {
            container.removeEventListener('click', handleClick);
        };

    }, [page]);

    const cleanHeadingBoldTags = (html) => {

        if (!html) return "";

        const temp = document.createElement("div");

        temp.innerHTML = html;

        const headings = temp.querySelectorAll(
            "h1, h2, h3, h4, h5, h6"
        );

        headings.forEach((heading) => {

            heading.innerHTML = heading.innerHTML
                .replace(/<\/?b>/gi, "")
                .replace(/<\/?strong>/gi, "");

        });

        return temp.innerHTML;
    };

   useEffect(() => {

        if (!menuLink?.length || !randomTest?.length || !HubTemplateSlugs?.length) {
            return;
        }

        // const testSlug = randomTest?.find(item => item.slug === slug);

        // if (testSlug) {
        //     navigate(`/${testSlug.slug}`, { replace: true });
        //     return;
        // }

        const FreeSlug = randomTest?.find(item => item.type == 'free_test');


        if (FreeSlug && (old_test_path === 'free-starter-quiz' || slug ==='free-starter-quiz') ) {

            navigate(`/${FreeSlug.slug}`, { replace: true });
            return;
        }

        // const reservedSlugs = menuLink.map(item => item?.menu_link);

        // if (reservedSlugs.includes(slug)) {

        //     navigate(`/${slug}`, { replace: true });
        //     return;
        // }

        fetchPage();

    }, [slug, menuLink,randomTest,HubTemplateSlugs]);

    const fetchPage = async () => {

        try {

            setLoading(true);

            const response = await axios.get( `${END_URL}/template/${slug}`);
               
            if (response.data.success && response.data.data) {

                const pageData = response.data.data;

                if (pageData?.contents) {

                    pageData.contents = pageData.contents.map(item => ({
                        ...item,
                        content: cleanHeadingBoldTags(item.content)

                    }));
                }
                
                setPage(pageData);

            } else {

                 navigate("/404", { replace: true });
            }

        } catch (error) {

            if ( error?.response?.data?.message === "Page not found"
           
            ) 
            {
                navigate("/404", { replace: true });

            } else {
                console.log(error);
                navigate("/404", { replace: true });
                setError("Failed to load page");
            }

        } finally {

            setLoading(false);
        }
    };

    if (loading) {

        return (
               <div className="loadingDiv" >
                
                    <img src={gg}  alt="Loading..." />
        
                </div>
        );
    }

    if (error) {

        return (
            <div className="container py-5 text-danger">
                {error}
            </div>
        );
    }

    return (
        <div className="priv-main">

            <div className="container">

                <div className="row">

                    <div className="col-md-12 priv-text-div">

                        <div className="priv-title">

                            <h1>
                                {page?.display_name}
                            </h1>

                        </div>

                        {page?.contents?.map((item) => (

                            <div
                                key={item.id}
                                className="priv-text"
                                dangerouslySetInnerHTML={{
                                    __html: item.content
                                }}
                            />

                        ))}

                    </div>

                </div>

            </div>

        </div>
    );
}

export default TemplatePage;